import type { KnowledgeCheckBlock, LocaleCode } from '@fixit/bozp-content';
import { useRef, useState } from 'react';
import { resolveLocalized } from '../locale';

/**
 * Ungraded self-check: reveals the authored explanation after a choice
 * (engagement only). Reports the first answer select via onInteract(block.id).
 */
export function KnowledgeCheckBlockView({
  block,
  locale,
  onInteract,
}: {
  block: KnowledgeCheckBlock;
  locale: LocaleCode;
  onInteract?: (widgetId: string) => void;
}) {
  const [picked, setPicked] = useState<string | null>(null);
  const fired = useRef(false);
  const pick = (choiceId: string) => {
    setPicked(choiceId);
    if (!fired.current) {
      fired.current = true;
      onInteract?.(block.id);
    }
  };
  return (
    <div data-block-type="knowledgeCheck">
      <p>{resolveLocalized(block.prompt, locale)}</p>
      <ul>
        {block.choices.map((choice) => (
          <li key={choice.id}>
            <button
              type="button"
              data-choice-id={choice.id}
              data-selected={picked === choice.id ? 'true' : undefined}
              aria-pressed={picked === choice.id}
              onClick={() => pick(choice.id)}
            >
              {resolveLocalized(choice.label, locale)}
            </button>
          </li>
        ))}
      </ul>
      {picked !== null && block.explanation ? (
        <p data-kc-explanation data-kc-correct={picked === block.correctChoiceId}>
          {resolveLocalized(block.explanation, locale)}
        </p>
      ) : null}
    </div>
  );
}
